import { format, parseISO } from 'date-fns';

/**
 * Formats a date string to a human-readable format
 * @param dateString - ISO date string to format
 * @param formatString - Optional format string (defaults to 'PPP p' - e.g., "Apr 29, 2025, 12:00 PM")
 * @returns Formatted date string
 */
export const formatDateTime = (dateString: string, formatString: string = 'PPP p'): string => {
  try {
    const date = parseISO(dateString);
    return format(date, formatString);
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};

/**
 * Formats a date string to date only (no time)
 * @param dateString - ISO date string to format
 * @returns Formatted date string (e.g., "Apr 29, 2025")
 */
export const formatDate = (dateString: string): string => {
  return formatDateTime(dateString, 'PPP');
};

/**
 * Formats a date string to time only (no date)
 * @param dateString - ISO date string to format
 * @returns Formatted time string (e.g., "12:00 PM")
 */
export const formatTime = (dateString: string): string => {
  return formatDateTime(dateString, 'p');
};

/**
 * Checks if a date is in the past
 * @param dateString - ISO date string to check
 * @returns True if the date is in the past
 */
export const isDateInPast = (dateString: string): boolean => {
  try {
    const date = parseISO(dateString);
    return date < new Date();
  } catch (error) {
    console.error('Error checking if date is in past:', error);
    return false;
  }
};

/**
 * Checks if a date is in the future
 * @param dateString - ISO date string to check
 * @returns True if the date is in the future
 */
export const isDateInFuture = (dateString: string): boolean => {
  try {
    const date = parseISO(dateString);
    return date > new Date();
  } catch (error) {
    console.error('Error checking if date is in future:', error);
    return false;
  }
};
